import { useState } from 'react';
import { faqItems } from '@/mocks/content';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest mb-3">
            Got Questions?
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Frequently Asked Questions About <span className="italic text-primary-500">Kakobuy Spreadsheet</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all ${
                  openIndex === index
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}